import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import {Grid, Alert} from 'react-bootstrap'
import {discardStatus} from '../../core/redux/status'
import style from './StatusAlert.less'

class StatusAlert extends Component {
    static propTypes = {
        spacer: PropTypes.bool
    }

    render() {
        const {dispatch, status, spacer} = this.props

        const transitionName = {
            enter: style.enter,
            enterActive: style.enterActive,
            leave: style.leave,
            leaveActive: style.leaveActive
        }

        return (
            <ReactCSSTransitionGroup
                transitionName={transitionName}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}>
                {status && (
                    <div className={style.default}>
                        <div className={style.content}>
                            <Grid>
                                <Alert
                                    bsStyle={status.type}
                                    onDismiss={() => dispatch(discardStatus())}>
                                    <p>{status.message}</p>
                                </Alert>
                            </Grid>
                        </div>
                        {spacer && (
                            <div className={style.spacer} />
                        )}
                    </div>
                )}
            </ReactCSSTransitionGroup>
        )
    }
}

StatusAlert = connect((state) => ({
    status: state.status
}))(StatusAlert)

export default StatusAlert


// WEBPACK FOOTER //
// ./lib/app/components/StatusAlert.js